export enum FeaturesAppsE {
  WarrChirp = 'warrchirp',
  Chirp = 'chirp',
  WarrCloud = 'warrcloud',
  WarrBots = 'warrbots',
}
export enum FeaturesNamesE {
  Schedule = 'schedule',
}
